import { IOptionRecord } from '@/store/types';

interface IBoolMap {
  trueText?: string;
  falseText?: string;
  trueColor?: string;
  falseColor?: string;
}

type IOptionValue = Array<string | number>;

// 渲染布尔类型的值
export function renderBool(trueValue: boolean, map?: IBoolMap) {
  const text = trueValue ? (map?.trueText || '是') : (map?.falseText || '否');
  const color = trueValue ? (map?.trueColor || '') : (map?.falseColor || '');
  return color ? `<span class="${color}">${text}</span>` : text;
}

// 渲染字典
export function renderOptions(values: IOptionValue, allOptions: IOptionRecord[]) {
  const list = values.map((item) => `${item}`);
  const found = allOptions.filter((item) => list.indexOf(item.optionKey) > -1);
  return found.map((item) => item.optionValue).join('、');
}
